import { render, staticRenderFns } from "./EmailOtpVerification.vue?vue&type=template&id=93810920&scoped=true&"
import script from "./EmailOtpVerification.vue?vue&type=script&lang=js&"
export * from "./EmailOtpVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailOtpVerification.vue?vue&type=style&index=0&id=93810920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93810920",
  null
  
)

export default component.exports